import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { pkdFilesFilterFields } from "./fields";

const PKDFilesFilter = () => {
  const { t } = useTranslation();

  const fields = useMemo(() => pkdFilesFilterFields(t), [t]);

  // Дефолтов для подстановки в URL нет: event приходит из навигации
  // (роут /pkd/:name/:name), остальные параметры фильтра изначально пусты.
  return <Filter.Root fields={fields} alwaysShow columns={3} />;
};

export default PKDFilesFilter;
